module.exports = __webpack_public_path__ + "img/permasense-et410.33dffd2f.png";